import { CardPaymentErrorAction } from './types';

/** No response at all, as opposed to the API refusing the request. */
export const NO_RESPONSE = 'no_response';

export const GENERAL_PAYMENT_ERROR = 'Sorry, something went wrong and you have not been charged. Please try again.';

type CardPaymentError = { message: string; action?: CardPaymentErrorAction };

const errors: { [code: string]: CardPaymentError } = {
  payment_amount_mismatch: {
    message: 'The price has changed since it was shown. Please check the updated total and try again.',
    action: 'reprice',
  },
  Invalid_RegistrationToken: {
    message: 'Your sign-up session has expired. Please sign in to finish your purchase.',
    action: 'signIn',
  },
  payment_just_completed: {
    message: 'A payment for your school has just gone through. Please check your subscriptions before paying again.',
    action: 'subscriptions',
  },
  No_valid_package_selected: { message: 'The selected packages are no longer available. Please choose again.' },
  Invalid_PackageID: { message: 'The selected packages are no longer available. Please choose again.' },
  Duplicate_SubjectID: { message: 'Please choose one package per subject.' },
  Invalid_PromoCode: { message: 'One of your promo codes is not valid. Please remove it and try again.' },
  Invalid_PromoCode_NotStarted: { message: 'One of your promo codes is not active yet. Please remove it and try again.' },
  Invalid_PromoCode_Expired: { message: 'One of your promo codes has expired. Please remove it and try again.' },
  Invalid_PromoCode_UsedAlready: { message: 'One of your promo codes has already been used. Please remove it and try again.' },
  pkey_general_payment_card_error: { message: 'Your card could not be charged. Please check your card details and try again.' },
};

/** The message for an API error code, and what the page should offer alongside it. */
export const cardPaymentError = (code: string): CardPaymentError =>
  errors[code] || { message: GENERAL_PAYMENT_ERROR };
